import React from 'react'
import { connect } from 'redaction'

import NoAuth from './NoAuth/NoAuth'
import HasAuth from './HasAuth/HasAuth'


const HeaderExceptMobile = ({ isLoggedIn, ...rest }) =>
  React.createElement(isLoggedIn ? HasAuth : NoAuth, rest)

export default connect({
  isLoggedIn: 'models.me.isLoggedIn',
})(HeaderExceptMobile)
